export default __webpack_public_path__ + "static/media/coffee-button.4ccacc36.svg";